// AUTO-GENERATED by scripts/design-system/build-icon-registry.ts — do not edit.
// Phosphor icons discovered in JSX icon="…" / <Icon name="…"> literals AND in
// object-property icon literals (e.g. { icon: "…" }) across nextjs-app + app.
// Merged into iconRegistry's bundled set so these icons register themselves
// without a manual edit. Run `npm run build:icons`.
import {
  Archive,
  ArrowClockwise,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowUp,
  ArrowsClockwise,
  Article,
  Bookmark,
  Briefcase,
  CalendarCheck,
  CalendarX,
  Camera,
  CaretDoubleLeft,
  CaretDoubleRight,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  CaretUpDown,
  Check,
  CheckCircle,
  Clipboard,
  CloudArrowUp,
  CopySimple,
  Cube,
  DotsThree,
  DotsThreeVertical,
  Download,
  DribbbleLogo,
  FacebookLogo,
  FileText,
  Folder,
  FolderOpen,
  Funnel,
  Gear,
  GithubLogo,
  House,
  Image,
  Info,
  InstagramLogo,
  Lightning,
  LinkedinLogo,
  List,
  MagnifyingGlass,
  MediumLogo,
  Moon,
  Newspaper,
  NewspaperClipping,
  PaperPlaneTilt,
  Pencil,
  Plus,
  QuestionMark,
  RedditLogo,
  ShareNetwork,
  SignOut,
  Sparkle,
  Star,
  Sun,
  TextAlignLeft,
  Trash,
  Tray,
  User,
  Warning,
  WarningCircle,
  WhatsappLogo,
  X,
  XCircle,
  XLogo,
} from "@phosphor-icons/react/ssr";

export const DISCOVERED_ICONS = {
  Archive,
  ArrowClockwise,
  ArrowLeft,
  ArrowRight,
  ArrowSquareOut,
  ArrowUp,
  ArrowsClockwise,
  Article,
  Bookmark,
  Briefcase,
  CalendarCheck,
  CalendarX,
  Camera,
  CaretDoubleLeft,
  CaretDoubleRight,
  CaretDown,
  CaretLeft,
  CaretRight,
  CaretUp,
  CaretUpDown,
  Check,
  CheckCircle,
  Clipboard,
  CloudArrowUp,
  CopySimple,
  Cube,
  DotsThree,
  DotsThreeVertical,
  Download,
  DribbbleLogo,
  FacebookLogo,
  FileText,
  Folder,
  FolderOpen,
  Funnel,
  Gear,
  GithubLogo,
  House,
  Image,
  Info,
  InstagramLogo,
  Lightning,
  LinkedinLogo,
  List,
  MagnifyingGlass,
  MediumLogo,
  Moon,
  Newspaper,
  NewspaperClipping,
  PaperPlaneTilt,
  Pencil,
  Plus,
  QuestionMark,
  RedditLogo,
  ShareNetwork,
  SignOut,
  Sparkle,
  Star,
  Sun,
  TextAlignLeft,
  Trash,
  Tray,
  User,
  Warning,
  WarningCircle,
  WhatsappLogo,
  X,
  XCircle,
  XLogo,
} as const;
